import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// Import Keycloak provider and config
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak";

const basename = "/home-ui"; // IIS virtual directory name

// Optional: Logging for debugging authentication issues
const keycloakEventLogger = (event: any, error: any) => {
  console.log("[Keycloak Event]", event, error);
};

const keycloakTokenLogger = (tokens: any) => {
  console.log("[Keycloak Tokens]", tokens);
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "login-required",    // Forces login
      checkLoginIframe: false,     // Prevent Cloudflare tunnel issues
      pkceMethod: "S256",          // Recommended security practice
    }}
    onEvent={keycloakEventLogger}   // Optional: log Keycloak lifecycle events
    onTokens={keycloakTokenLogger}  // Optional: log tokens (access/refresh)
  >
    <Provider store={store}>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </Provider>
  </ReactKeycloakProvider>
);

reportWebVitals();
